module.exports = __webpack_public_path__ + "img/MDI-calendar-month.87d08ee0.svg";